import { useRouter } from 'next/router';
import { useMemo } from 'react';

/**
 * Custom hook to detect if there are any active filters in the URL
 * This works by checking for query parameters that start with 'f.' (facet prefix)
 * @returns boolean indicating if there are active filters
 */
export const useActiveFilters = (): boolean => {
    const router = useRouter();

    const hasActiveFilters = useMemo(() => {
        if (!router.query) return false;

        // Check if any query parameter starts with 'f.' (facet prefix)
        return Object.keys(router.query).some(key => {
            const value = router.query[key];
            return key.startsWith('f.') &&
                value &&
                (Array.isArray(value) ? value.length > 0 : true);
        });
    }, [router.query]);

    return hasActiveFilters;
};
